export class ContasPagarGetAllRequest {
    pesquisa: string | null;
    refinamento: number | null;
    dataInicio: string | null;
    dataFim: string | null;
    idStatus: number | null;
    idCategoria: number | null;
    idFormaPagamento: number | null;
    tags: number[] | null;
    listaIdFornecedor: number[] | null;
}
